import { computed, type ComputedRef } from 'vue'

import { useRoute, useRouter } from 'nuxt/app'

import { useCoursesSearchContext } from '@courses/search-layer/composables/useCoursesSearchContext'

import { useCommunitiesSearchContext } from '@communities/common-layer/composables/useCommunitiesSearchContext'

import type { SearchContext } from '@common/shared-ui-layer/types/search-context'

export function useActiveSearchContext(): {
  searchContext: ComputedRef<SearchContext | null>
} {
  const route = useRoute()
  const router = useRouter()

  const coursesContext = useCoursesSearchContext(route, router)
  const communitiesContext = useCommunitiesSearchContext(route, router)

  const searchContext = computed<SearchContext | null>(() => {
    const name = route.name?.toString() ?? ''

    if (
      name.startsWith('courses-products') ||
      name.startsWith('courses-search') ||
      name === 'my-library' ||
      route.path.includes('/courses/my-library') ||
      route.path.includes('/communities/my-library')
    ) {
      return coursesContext
    }
    if (name.startsWith('communities-groups-')) {
      return communitiesContext
    }
    return null
  })

  return { searchContext }
}
